import axios from "axios";

const setFavCount = ({commit}) => {
    let params = new URLSearchParams();
    params.append('action', 'setFavCount');
    axios.get('/rest/product', {params})
        .then((response) => {
            const data = JSON.parse(response.data);
            commit('SET_FAV_COUNT', data)
        }).catch(error => console.log(error))

}

const getCompareInfo = ({commit}, payload) => {
    let params = new URLSearchParams();
    params.append('action', 'getCompareInfo');
    params.append('product_id', payload.product_id);
    params.append('option', payload.option);
    axios.get('/rest/product', {params})
        .then((response) => {
            const data = JSON.parse(response.data);
            data.added = payload.is_ok;
            commit('SET_COMPARE_INFO', data)
        }).catch(error => console.log(error))
}

const addToFav = ({commit, dispatch}, payload) => {
    let params = new URLSearchParams();
    params.append('action', 'addToFav');
    params.append('product_id', payload.product_id);
    axios.post('/rest/product', params)
        .then((response) => {
            const data = JSON.parse(response.data);
            dispatch('setFavCount')
            dispatch('addToWishlist',data)

        }).catch(error => console.log(error))
}

const removeFromFav = ({commit, dispatch}, payload) => {
    let params = new URLSearchParams();
    params.append('action', 'removeFromFav');
    params.append('product_id', payload.product_id);
    axios.delete('/rest/product', {data:params})
        .then(() => {
            dispatch('setFavCount')

        }).catch(error => console.log(error))
}

const addToCompare = ({commit, dispatch}, payload) => {
    let params = new URLSearchParams();
    params.append('action', 'addToCompare');
    params.append('product_id', payload.product_id);
    axios.post('/rest/product', params)
        .then((response) => {
            const data = JSON.parse(response.data);
            dispatch('getCompareInfo', {product_id: payload.product_id, option: 1, is_ok: data})

        }).catch(error => console.log(error))
}

const removeFromCompare = ({commit, dispatch}, payload) => {
    let params = new URLSearchParams();
    params.append('action', 'removeFromCompare');
    params.append('product_id', payload.product_id);
    axios.delete('/rest/product', {data:params})
        .then((response) => {
            dispatch('getCompareInfo',{product_id: payload.product_id, option: 0, is_ok: true})

        }).catch(error => console.log(error))
}

const getFirms = ({commit}) => {
    let params = new URLSearchParams();
    params.append('param', 'get-firms');
    axios.get('/rest/profile', {params})
        .then((response) => {
            commit("SET_FIRMS", response.data);
        })
        .catch(error => console.log(error));
}

const setDefaultFirm = async ({commit}, payload) => {
    let params = new URLSearchParams();
    params.append('action', 'set-default-firm');
    params.append('firm_id', payload);
    await axios.put('/rest/profile', params)
        .then((response) => {
            commit("SET_FIRMS", response.data);
        })
        .finally(() => {
            return new Promise(resolve => {
                resolve()
            })
        });
}

// update organization data
const updateFirm = async (context, payload) => {

    let params = new URLSearchParams();
    params.append('data', JSON.stringify(payload));
    params.append('action', 'update-firm');

    await axios.put('/rest/profile', params)
        .then((response) => {
            if(response.data.error !== '') {
                context.commit("SET_MESSAGE", response.data.error);
                context.commit("SET_VALIDATION", {form: "firm", data: response.data.validation})
            } else {
                context.commit("SET_MESSAGE", "");
                context.commit("RESET_VALIDATION", "firm")
                context.commit("SET_FIRMS", response.data.firms);
            }
        })
        .catch((error) => {
            context.commit("SET_MESSAGE", "ошибка сервера: " + error.response.status);
        })
        .finally(function(){
            return new Promise(resolve => {
                resolve()
            })
        })
}

const deleteFirm = async ({commit}, payload) => {

    let params = new URLSearchParams();
    params.append('id', payload.id);
    params.append('action', 'delete_firm');

    await axios.delete('/rest/profile', {data:params})
        .then((response) => {
            commit("SET_FIRMS", response.data);
        })
        .catch((error) => {
            commit("SET_MESSAGE", "ошибка сервера: " + error.response.status);
        })
        .finally(() => {
            return new Promise(resolve => {
                resolve()
            })
        })

}
const addFirm = async ({commit}) => {
    let params = new URLSearchParams();
    params.append('action', 'add_firm');

    await axios.post('/rest/profile', params)
        .then((response) => {
            commit("SET_FIRMS", response.data);
        })
        .catch((error) => {
            commit("SET_MESSAGE", "ошибка сервера: " + error.response.status);
        })
        .finally(() => {
            return new Promise(resolve => {
                resolve()
            })
        })
}

export default {
    setFavCount,
    getCompareInfo,
    addToFav,
    removeFromFav,
    addToCompare,
    removeFromCompare,
    getFirms,
    setDefaultFirm,
    updateFirm,
    deleteFirm,
    addFirm
}
